import React, { useState } from 'react'

import { 
    Box,
    Typography,
    Paper,
    Container,
    Grid,
    TextField,
    styled,
    Card
} from '@mui/material';

import {
  LoadingButton
} from '@mui/lab';

import * as yup from "yup"
import { Formik, Form } from 'formik';

import CommonBreadcumbs from '../../../components/common/CommonBreadcumbs';
import CommonSectionHeader from '../../../components/common/CommonSectionHeader';

import { useAuth } from '../../../hooks/api/useAuth';
import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useAuthAccess } from '../../../hooks/useAuthAccess';
import { routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';

import { validationSchema, initialValues } from '../../../schema/users/passwordSchema'

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function PasswordPage() {

    const { promptMessage } = useSystemPrompt();
    const { isLoading, changePassword }  = useAuth();
    const { authData } = useAuthAccess();
    const { getHtmlHead } = useSystemHead(routeTypes.customer)

    const [ id, setId ] = useState(authData?.userId)

    const onSubmit = async (currentValues) => {

        try{
            
            const response = await changePassword({ 
                current: currentValues.passwordcurrent,
                password: currentValues.password,
                confirm: currentValues.passwordconfirm
            });

            promptMessage(true, `${response?.message}`)
                
        }catch(error){

            promptMessage(false, `Action Failed (${error?.message})`)
        }   

    }

    const RenderForm = () => {
        return(
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                
            {
                ({ values, errors, touched, handleChange, setFieldValue}) => (
                    <Form>
                        <StyledCard>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                    
                                    <CommonSectionHeader
                                        title={`Change Credential`}
                                        subTitle={`Verify account ownership`}
                                    />
                                    
                                </Grid>
                                <Grid item xs={12} sm={12} md={8}>

                                    <Grid container spacing={1} textAlign={"left"}>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <TextField
                                                margin="dense"
                                                size="small"
                                                autoFocus
                                                fullWidth
                                                name={"passwordcurrent"}
                                                label="Current Password"
                                                type="password"                                         
                                                variant="outlined"
                                                value={values.passwordcurrent}
                                                onChange={handleChange}
                                                error={touched.passwordcurrent && Boolean(errors.passwordcurrent)}
                                                helperText={touched.passwordcurrent && errors.passwordcurrent}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6}><></></Grid>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <TextField
                                                margin="dense"
                                                size="small"
                                                autoFocus
                                                fullWidth
                                                name={"password"}
                                                label="Password"
                                                type="password"                                         
                                                variant="outlined"
                                                value={values.password}
                                                onChange={handleChange}
                                                error={touched.password && Boolean(errors.password)}
                                                helperText={touched.password && errors.password}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <TextField
                                                margin="dense"
                                                size="small"
                                                autoFocus
                                                fullWidth
                                                name={"passwordconfirm"}
                                                label="Confirm Password"
                                                type="password"                                         
                                                variant="outlined"
                                                value={values.passwordconfirm}
                                                onChange={handleChange}
                                                error={touched.passwordconfirm && Boolean(errors.passwordconfirm)}
                                                helperText={touched.passwordconfirm && errors.passwordconfirm}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                
                            </Grid>
                        </StyledCard>
                        <Grid container spacing={1} sx={{ pl: 2, pr: 2}}>
                            <Grid item md={12} textAlign={"right"}>
                                <LoadingButton
                                    type="submit"
                                    // fullWidth
                                    variant="contained"
                                    sx={{ 
                                        mt: 3,
                                        mb: 2
                                    }}
                                    loading={isLoading}
                                >
                                    Save Changes
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </Form>
                )
            }
            </Formik>
        )
    }

    return (
        <Box>
            {  
                getHtmlHead({ routeType: routeTypes.customer, title: headTitles.password })
            }

            <CommonBreadcumbs
                routeType={routeTypes.customer}
                pageTitle="Change Password"
                breadcrumbs={[
                    {
                        displayText: "Change Password",
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            { RenderForm() }

        </Box>
    )
}
